import NiceModal, { useModal } from "@ebay/nice-modal-react"
import { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import SideModal from '/src/components/modal/SideModal/SideModal'
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from "/src/components/form/Form";
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import InputRange from '/src/components/UI/InputRange/InputRange';
import ButtonAction from "/src/components/UI/Button/Button";
import TodoList from '/src/components/UI/TodoList/TodoList';
import StatementModalBody from "./StatementModalBody"
import "./StatementModal.css"
import "/src/assets/css/polices.css";
import TextInput from '/src/components/UI/TextField/TextInput';
import TodoList from '/src/components/UI/TodoList/TodoList';
import { checkNumber } from "/src/features/plugins/dashboard/checkNumber";
import InputDate from '/src/components/UI/InputDate/InputDate'
import useRegex from "../../hooks/useRegex";
const StatementBlock = ({ setValue, column, data, registerObject }) => {

    const inputRef = useRef();
    // 0 text
    // 1 number
    // 2 array 
    // 3 date
    //console.log(column)
    //console.log(data)
    const [error, setError] = useState(false);
    const {regex} = useRegex();

    const checkError = (text) => {
        if (column.rule == 0) return;
        let regex = new RegExp(column.rule.replace(/^\/|\/$/g, ''))
        if (regex.test(text) == true){
            setError(false)
            registerObject.clearErrors(column.id)
        }
        else{
            setError(true)
            registerObject.setError(column.id,"error")
        }
    }

    /*
    const getNameRegexByRule = (rule) =>{
        console.log(regex)
        console.log(rule)
        if (regex.length == 0) return rule;
        console.log("-----------")
        console.log(regex.find(r => { return r.rule === rule; }))
        return regex.filter( (r) => r.value === rule).name;
    }   
    */
    const errorLabel = <div style={{color : "var(--pink)", fontSize : "14px"}}> Error - Regex : {column.rule} </div>

    return (
        <div>
            {
                column.type == "keyword" &&
                <div>
                    <TextInput ref={inputRef} defaultValue={data} onChange={(e) => { setValue(column.id, e.target.value); checkError(e.target.value) }} />
                    {error &&  errorLabel}
                </div>
            }
            {
                column.type == "integer" &&
                <TextInput ref={inputRef} onKeyDown={(e) => checkNumber(e)} type="number" className="input_number_statement_block" defaultValue={data} onChange={(e) => setValue(column.id, e.target.value)} />
            }
            {
                column.type == "text" &&
                <div>
                    {error && errorLabel}
                    <TodoList control={registerObject.control} registerObject={registerObject} name={column.id} checkError={checkError}></TodoList>
                </div>
            }
            {
                column.type == "date" &&
                <InputDate width={275}></InputDate>
            }

        </div>
    )
};

export default StatementBlock;